(function () {
  function initSel2Header(root) {
    if (!root || root.dataset.sel2HeaderReady === '1') return;
    root.dataset.sel2HeaderReady = '1';

    var toggle = root.querySelector('[data-sel-2-header-toggle]');
    var drawer = root.querySelector('[data-sel-2-header-drawer]');

    if (toggle && drawer) {
      toggle.addEventListener('click', function () {
        var open = root.classList.toggle('is-menu-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        document.documentElement.classList.toggle('sel-2-header-menu-open', open);
      });

      drawer.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', function () {
          root.classList.remove('is-menu-open');
          toggle.setAttribute('aria-expanded', 'false');
          document.documentElement.classList.remove('sel-2-header-menu-open');
        });
      });
    }

    if (root.classList.contains('sel-2-header--sticky')) {
      var onScroll = function () {
        root.classList.toggle('is-scrolled', window.scrollY > 8);
      };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    var fullNavMin = parseInt(root.getAttribute('data-sel-2-nav-full-min') || '1320', 10);
    if (!fullNavMin || fullNavMin < 990) fullNavMin = 1320;

    window.addEventListener('resize', function () {
      // Close drawer only when the full desktop menu is active (no hamburger)
      if (window.matchMedia('(min-width: ' + fullNavMin + 'px)').matches) {
        root.classList.remove('is-menu-open');
        document.documentElement.classList.remove('sel-2-header-menu-open');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  function boot() {
    document.querySelectorAll('[data-sel-2-header]').forEach(initSel2Header);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector('[data-sel-2-header]');
    if (root) initSel2Header(root);
  });
})();
